<drill-activity-chart
  [blasts]="blasts()"
  [shiftConfig]="shiftConfig()"
  [timeScale]="timeScale()"
  [startDate]="startDate()"
  [endDate]="endDate()"
  (blastClick)="navigateToBlast($event)"
  (sessionClick)="navigateToSession($event)"
  (dateRangeChange)="onDateRangeChange($event)"
/>
